import { env } from 'config';

export const EDITOR_CONSTANTS = {
  ENV: {
    TIP_TAP_APP_ID: env.REACT_APP_TIP_TAP_APP_ID || '',
    TIP_TAP_TOKEN: env.REACT_APP_TIP_TAP_TOKEN || '',
    TIP_TAP_AI_APP_ID: env.REACT_APP_TIP_TAP_AI_APP_ID || '',
    TIP_TAP_CONVERT_APP_ID: env.REACT_APP_TIP_TAP_CONVERT_APP_ID || '',
    TIP_TAP_AI_TOKEN: env.REACT_APP_TIP_TAP_AI_TOKEN || '',
  },
} as const;
